import { COLUMN_TYPES } from "../../constants/common";

export const DefaultBundleColumns = [
  {
    exportLabel: "Bundle Name",
    fieldName: "name",
    label: "Bundle Name",
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    sort: true,
    width: 150,
  },
  {
    exportLabel: "LOB",
    fieldName: "lineOfBusinessList",
    label: "LOB",
    isSelected: true,
    type: COLUMN_TYPES.MULTI_VALUE,
    showInSelection: true,
    width: 140,
  },
  {
    fieldName: "countryName",
    label: "Country",
    exportLabel: "Country",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 100,
  },
  {
    fieldName: "states",
    label: "State/Province",
    exportLabel: "State/Province",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.MULTI_VALUE,
    showInSelection: true,
    width: 150,
  },
  {
    fieldName: "latestVersion",
    label: "Edition Date",
    exportLabel: "Edition Date",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "enterpriseUsersWithAccess",
    label: "Enterprise",
    exportLabel: "Enterprise",
    sort: false,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 250,
  },
  {
    fieldName: "keywords",
    label: "Keywords",
    exportLabel: "Keywords",
    sort: false,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 100,
  },
  {
    fieldName: "marketingDescription",
    label: "Marketing Description",
    exportLabel: "Marketing Description",
    sort: false,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },

  {
    fieldName: "createdOn",
    label: "Created Date",
    exportLabel: "Created Date",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.DATE,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "createdByName",
    label: "Created By",
    exportLabel: "Created By",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "updatedOn",
    label: "Last Updated Date",
    exportLabel: "Last Updated Date",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.DATE,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "updatedByName",
    label: "Last Updated By",
    exportLabel: "Last Updated By",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "numberOfEnrolledUser",
    label: "Number of Enrolled Users",
    exportLabel: "Number of Enrolled Users",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 230,
  },

  {
    fieldName: "isPublic",
    label: "Available to Public",
    exportLabel: "Available to Public",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BOOLEAN,
    YesLabelText: "Yes",
    NoLabelText: "No",
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "contentTypeText",
    label: "Bundle Type(Free/Paid)",
    exportLabel: "Bundle Type(Free/Paid)",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 220,
  },

  {
    fieldName: "publishStatus",
    label: "Published",
    exportLabel: "Published",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BOOLEAN,
    YesLabelText: "Published",
    NoLabelText: "Draft",
    showInSelection: true,
  },
  {
    exportLabel: "Status",
    fieldName: "status",
    label: "Status",
    isSelected: true,
    type: COLUMN_TYPES.STATUS_CHANGE,
    showInSelection: true,
    activeLabelText: "Active",
    inactiveLabelText: "Inactive",
    isFixed: true,
    sort: true,
    width: 200,
    rightPadding: 190,
  },
  {
    fieldName: "action",
    label: "",
    exportLabel: "",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.ACTION,
    showInSelection: true,
    isFixed: true,
    rightPadding: 0,
    width: 190,
    options: [
      {
        label: "Add to Favourite",
        testId: "favourite",
        status: "isFavorite",
        iconPath: "/images/favorite_enable.png",
        iconPathInactive: "/images/unfavorite_enable.png",
        disabled: false,
        testIdText: "favorite",
        activeTitle: "Add to Favorite",
        deactiveTitle: "Remove Favorite",
      },
      {
        label: "Delete",
        testId: "delete",
        status: "publishStatus",
        iconPath: "/images/delete_disable.png",
        iconPathInactive: "/images/delete_enable.png",
        disabled: false,
        testIdText: "DeleteIcon",
        activeTitle: "Delete Content",
        deactiveTitle: "Published content cannot be deleted",
      },
      {
        label: "Copy",
        testId: "copy",
        iconPath: "/images/copy-icon.png",
        iconPathInactive: "/images/copy-icon.png",
        disabled: false,
        testIdText: "CopyIcon",
        activeTitle: "Copy Content",
        deactiveTitle: "Copy Content",
      },
    ],
  },
];

export const CustomListBundleColumns = [
  {
    exportLabel: "Content/Catalog Id",
    fieldName: "contentId",
    label: "Content/Catalog Id",
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    sort: true,
    width: 230,
  },
  {
    exportLabel: "Content/Catalog Name",
    fieldName: "name",
    label: "Content/Catalog Name",
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    sort: true,
    width: 230,
  },
  {
    exportLabel: "Types – Content / Catalog",
    fieldName: "documentType",
    label: "Types – Content / Catalog",
    isSelected: false,
    type: COLUMN_TYPES.DOCTYPE,
    showInSelection: true,
    sort: true,
    width: 230,
  },
  {
    fieldName: "userName",
    label: "Distributor",
    exportLabel: "Distributor",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    exportLabel: "LOB",
    fieldName: "lineOfBusinessList",
    label: "LOB",
    isSelected: true,
    type: COLUMN_TYPES.MULTI_VALUE,
    showInSelection: true,
    width: 170,
  },
  {
    exportLabel: "Type of Forms",
    fieldName: "typeOfFormList",
    label: "Type of Forms",
    isSelected: false,
    type: COLUMN_TYPES.MULTI_VALUE,
    showInSelection: true,
    sort: true,
    width: 170,
  },
  {
    fieldName: "tages",
    label: "Content Tags/Labels",
    exportLabel: "Content Tags/Labels",
    sort: false,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "countryName",
    label: "Country",
    exportLabel: "Country",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 100,
  },
  {
    fieldName: "states",
    label: "State/Province",
    exportLabel: "State/Province",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.MULTI_VALUE,
    showInSelection: true,
    width: 150,
  },
  {
    fieldName: "latestVersion",
    label: "Edition Date",
    exportLabel: "Edition Date",
    sort: true,
    isSelected: true,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "keywords",
    label: "Keywords",
    exportLabel: "Keywords",
    sort: false,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 100,
  },
  {
    fieldName: "marketingDescription",
    label: "Marketing Description",
    exportLabel: "Marketing Description",
    sort: false,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "createdOn",
    label: "Created Date",
    exportLabel: "Created Date",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.DATE,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "createdByName",
    label: "Created By",
    exportLabel: "Created By",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "updatedOn",
    label: "Last Updated Date",
    exportLabel: "Last Updated Date",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.DATE,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "updatedByName",
    label: "Last Updated By",
    exportLabel: "Last Updated By",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "numberOfEnrolledUser",
    label: "Number of Enrolled Users",
    exportLabel: "Number of Enrolled Users",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 230,
  },
  {
    fieldName: "isPublic",
    label: "Available to Public",
    exportLabel: "Available to Public",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BOOLEAN,
    YesLabelText: "Yes",
    NoLabelText: "No",
    showInSelection: true,
    width: 200,
  },
  {
    fieldName: "publishStatus",
    label: "Published",
    exportLabel: "Published",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BOOLEAN,
    YesLabelText: "Published",
    NoLabelText: "Draft",
    showInSelection: true,
    width: 120,
  },
  {
    fieldName: "IsDisplayPublic",
    label: "IsDisplayPublic",
    exportLabel: "IsDisplayPublic",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 150,
  },
  {
    fieldName: "contentTypeText",
    label: "Content/Catalog Type(Free/Paid)",
    exportLabel: "Content/Catalog Type(Free/Paid)",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 300,
  },
  {
    fieldName: "fillableText",
    label: "Fillable",
    exportLabel: "Fillable",
    sort: true,
    isSelected: false,
    type: COLUMN_TYPES.BASIC,
    showInSelection: true,
    width: 100,
  },
  {
    fieldName: "status",
    label: "Status",
    exportLabel: "Status",
    isSelected: true,
    type: COLUMN_TYPES.ACTIVE_INACTIVE_LABEL,
    showInSelection: true,
    sort: true,
    activeLabelText: "Active",
    inactiveLabelText: "Inactive",
    width: 150,
    isFixed: true,
    rightPadding: 190,
    cssClass: "status-change",
  },
  {
    fieldName: "action",
    label: "",
    exportLabel: "",
    sort: false,
    isSelected: true,
    type: COLUMN_TYPES.ACTION,
    showInSelection: true,
    isFixed: true,
    rightPadding: 0,
    width: 190,
    options: [
      {
        label: "Favourite",
        testId: "favourite",
        status: "isFavorite",
        iconPath: "/images/favorite_enable.png",
        iconPathInactive: "/images/unfavorite_enable.png",
        disabled: false,
        testIdText: "favorite",
        activeTitle: "Favorite",
        deactiveTitle: "Favorite",
      },
      {
        label: "Delete",
        testId: "delete",
        status: "publishStatus",
        iconPath: "/images/delete_disable.png",
        iconPathInactive: "/images/delete_enable.png",
        disabled: false,
        testIdText: "DeleteIcon",
        activeTitle: "Delete Content",
        deactiveTitle: "Published content cannot be deleted",
      },
      {
        label: "Copy",
        testId: "copy",
        iconPath: "/images/copy-icon.png",
        iconPathInactive: "/images/copy-icon.png",
        disabled: false,
        testIdText: "CopyIcon",
        activeTitle: "Copy Content",
        deactiveTitle: "Copy Content",
      },
    ],
  },
];
